import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { ActivatedRoute } from '@angular/router';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-eap-institutional-review-board',
  templateUrl: './eap-institutional-review-board.component.html',
  styleUrls: ['./eap-institutional-review-board.component.scss']
})
export class EapInstitutionalReviewBoardComponent implements OnInit {
  formFields;
  ApplicationID: string;
  reviewBoardOptions = [];
  permission: string = "";
  operations: any = [];
  userType: string = "";
  content: any;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  constructor(
    private modalService: NgbModal,
    private appFunctions: AppFunctionsService,
    private summaryService: IstSummaryService,
    private datashareService: IstDataShareService,
    private route: ActivatedRoute,
    public commonService: CommonService,
    private userService: UserService
  ) {

  }

  institutionalReviewBoardForm: UntypedFormGroup;
  ngOnInit() {

    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.permission = "";
    if (this.commonService.getPagePermission("EAP04") != null && this.commonService.getPagePermission("EAP04") != undefined) {
      this.permission = this.commonService.getPagePermission("EAP04").toLowerCase();
    }
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
      this.commonService.ValidationBanner("Please save the first form of the application, before navigating to the other forms.");
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Please save the first form of the application, before navigating to the other forms." } } });
      this.permission = "view";
      return false;
    }

    this.userType = this.userService.getUserType();
     ;
   // const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

    this.institutionalReviewBoardForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      APPLICATION_ID: new UntypedFormControl(null),
      NAME: new UntypedFormControl(null,[Validators.required]),
      WEB_SITE: new UntypedFormControl("", [Validators.required]),
      BOARD_TYPE_ID: new UntypedFormControl(null, [Validators.required]),
      ADDRESS: new UntypedFormControl(null),
      POSTAL_CODE: new UntypedFormControl(null),
      CITY: new UntypedFormControl(null),
      PROVINCE: new UntypedFormControl(null),
      COUNTRY: new UntypedFormControl(null),
      EMAIL: new UntypedFormControl(null),
      PHONE: new UntypedFormControl("", [
      Validators.maxLength(15)]),
      PHONE_EXT: new UntypedFormControl(null, [Validators.pattern("^[0-9]*$"),
      Validators.maxLength(5)]),
      OTHER_PHONE: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"),
      Validators.maxLength(15)]),
      OTHER_PHONE_EXT: new UntypedFormControl(null, [Validators.pattern("^[0-9]*$"),
      Validators.maxLength(5)]),
      FAX: new UntypedFormControl(null),
      FAX_EXT: new UntypedFormControl(null, [Validators.pattern("^[0-9]*$"),
      Validators.maxLength(5)]),
      NOTES: new UntypedFormControl(null),
    });

    if (this.permission != "view") {
      this.operations = [
        { name: 'Save', type: 'submit', callback: this.save, self: this }
      ];
    }
    else {
      this.institutionalReviewBoardForm.disable();
    }

    this.GetScreenMasterData();
    this.GetScreenData();
  }

  PostalCodekeyUP(value: string) {
    if (value.length == parseInt("5")) {
      this.commonService.getCity(value).subscribe(x => {
        if (x.Status) {
          this.institutionalReviewBoardForm.controls["CITY"].setValue(x.Data.City);
          this.institutionalReviewBoardForm.controls["PROVINCE"].setValue(x.Data.StateFullName);
          this.institutionalReviewBoardForm.controls["COUNTRY"].setValue(x.Data.Country);
        }
      });
    }
    else
    {
      this.institutionalReviewBoardForm.controls["CITY"].setValue("");
      this.institutionalReviewBoardForm.controls["PROVINCE"].setValue("");
      this.institutionalReviewBoardForm.controls["COUNTRY"].setValue("");
    }
  }


  onCallbackOperation(opr) {
    opr.callback(this.summaryService, this.institutionalReviewBoardForm, this.ApplicationID, this.extendedForm, this.validateControls);
}

  GetScreenMasterData() {
    this.summaryService.getScreenDataForEdit("api/EAPReviewBoard/GetReviewBoardMasterData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
    this.reviewBoardOptions = summary["MasterData1"];
  });
}
GetScreenData() {
  this.summaryService.getScreenDataForEdit("api/EAPReviewBoard/GetReviewBoardData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
    this.institutionalReviewBoardForm.patchValue({
      ID: summary["ID"],
      APPLICATION_ID: summary["APPLICATION_ID"],
      NAME: summary["NAME"],
      WEB_SITE: summary["WEB_SITE"],
      BOARD_TYPE_ID: summary["BOARD_TYPE_ID"],
      ADDRESS: summary["ADDRESS"],
      POSTAL_CODE: summary["POSTAL_CODE"],
      COUNTRY: summary["COUNTRY"],
      PROVINCE: summary["PROVINCE"],
      CITY: summary["CITY"],
      EMAIL: summary["EMAIL"],
      PHONE: summary["PHONE"],
      PHONE_EXT: summary["PHONE_EXT"],
      OTHER_PHONE: summary["OTHER_PHONE"],
      OTHER_PHONE_EXT: summary["OTHER_PHONE_EXT"],
      FAX: summary["FAX"],
      FAX_EXT: summary["FAX_EXT"],
      NOTES: summary["NOTES"],
    })
  });
}

  save() {
     ;
    if (this.validateControls() && this.extendedForm.validateControls()) {
      var formData = this.institutionalReviewBoardForm.value;
      formData.APPLICATION_ID = this.ApplicationID;
    formData.PHONE_EXT = parseInt(formData.PHONE_EXT);
    formData.OTHER_PHONE_EXT = parseInt(formData.OTHER_PHONE_EXT);
    formData.FAX_EXT = parseInt(formData.FAX_EXT);
    formData.RECORD_STATE = parseInt("0");
    formData.CREATED_DATE = new Date();
      formData.LAST_UPDATED_DATE = new Date();
      this.summaryService.Insert("api/EAPReviewBoard/Insert", formData).subscribe(summary => {
      this.extendedForm.saveControls(summary.TransactionCode).subscribe(result1 => {
        //this.modalService.show(MessageBoxComponent, { data: { heading: 'Save', content: { heading: '', description: 'Data Saved Successfully.' } } });
       this.commonService.SuccessBanner('Data Saved Successfully.');
      });

    });
  }
  }
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.institutionalReviewBoardForm.value;
    if (formData.NAME === null || formData.NAME === "") {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Name.<br/>";
      isValid = false;
    } else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.WEB_SITE === null || formData.WEB_SITE === "") {
      $("#WEB_SITE").addClass("ng-touched ng-invalid validate-error");
      $("#WEB_SITE").removeClass("ng-untouched ng-valid");
      message += "Please enter Web-Site.<br/>";
      isValid = false;
    } else {
      const website = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
      if (formData.WEB_SITE.match(website)) {
        $("#WEB_SITE").addClass("ng-untouched ng-valid");
        $("#WEB_SITE").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#WEB_SITE").addClass("ng-touched ng-invalid validate-error");
        $("#WEB_SITE").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Web-Site.<br/>";
        isValid = false;
      }
    }

    if (formData.BOARD_TYPE_ID === null || formData.BOARD_TYPE_ID === "") {
      $("#BOARD_TYPE_ID").addClass("ng-touched ng-invalid validate-error");
      $("#BOARD_TYPE_ID").removeClass("ng-untouched ng-valid");
      message += "Please select Board Type.<br/>";
      isValid = false;
    } else {
      $("#BOARD_TYPE_ID").addClass("ng-untouched ng-valid");
      $("#BOARD_TYPE_ID").removeClass("ng-touched ng-invalid validate-error");
    }


    if (formData.ADDRESS === null || formData.ADDRESS === "") {
      $("#ADDRESS").addClass("ng-touched ng-invalid validate-error");
      $("#ADDRESS").removeClass("ng-untouched ng-valid");
      message += "Please enter Address.<br/>";
      isValid = false;
    } else {
      $("#ADDRESS").addClass("ng-untouched ng-valid");
      $("#ADDRESS").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.POSTAL_CODE === null || formData.POSTAL_CODE === "") {
      $("#POSTAL_CODE").addClass("ng-touched ng-invalid validate-error");
      $("#POSTAL_CODE").removeClass("ng-untouched ng-valid");
      message += "Please enter Postal Code.<br/>";
      isValid = false;
    } else {
      $("#POSTAL_CODE").addClass("ng-untouched ng-valid");
      $("#POSTAL_CODE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.CITY === null || formData.CITY === "") {
      $("#CITY").addClass("ng-touched ng-invalid validate-error");
      $("#CITY").removeClass("ng-untouched ng-valid");
      message += "Please enter City.<br/>";
      isValid = false;
    } else {
      $("#CITY").addClass("ng-untouched ng-valid");
      $("#CITY").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.PROVINCE === null || formData.PROVINCE === "") {
      $("#PROVINCE").addClass("ng-touched ng-invalid validate-error");
      $("#PROVINCE").removeClass("ng-untouched ng-valid");
      message += "Please enter Province.<br/>";
      isValid = false;
    } else {
      $("#PROVINCE").addClass("ng-untouched ng-valid");
      $("#PROVINCE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.COUNTRY === null || formData.COUNTRY === "") {
      $("#COUNTRY").addClass("ng-touched ng-invalid validate-error");
      $("#COUNTRY").removeClass("ng-untouched ng-valid");
      message += "Please enter Country.<br/>";
      isValid = false;
    } else {
      $("#COUNTRY").addClass("ng-untouched ng-valid");
      $("#COUNTRY").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.EMAIL === null || formData.EMAIL === "" || formData.EMAIL === undefined) {
      $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
      $("#EMAIL").removeClass("ng-untouched ng-valid");
      message += "Please enter E-Mail.<br/>";
      isValid = false;
    } else {
      const mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (formData.EMAIL.match(mailformat)) {
        $("#EMAIL").addClass("ng-untouched ng-valid");
        $("#EMAIL").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
        $("#EMAIL").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid E-Mail.<br/>";
        isValid = false;
      }
    }
    if (formData.PHONE === null || formData.PHONE === "") {
      $("#PHONE").addClass("ng-touched ng-invalid validate-error");
      $("#PHONE").removeClass("ng-untouched ng-valid");
      message += "Please enter Phone Number.<br/>";
      isValid = false;
    } else {
      const phoneformat = /^[1-9]\d*$/;
      formData.PHONE = formData.PHONE + "";
      if (formData.PHONE.match(phoneformat)) {
        $("#PHONE").addClass("ng-untouched ng-valid");
        $("#PHONE").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#PHONE").addClass("ng-touched ng-invalid validate-error");
        $("#PHONE").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Phone Number.<br/>";
        isValid = false;
      }
    }

    if (formData.PHONE_EXT === null || formData.PHONE_EXT === "") {
      $("#PHONE_EXT").addClass("ng-touched ng-invalid validate-error");
      $("#PHONE_EXT").removeClass("ng-untouched ng-valid");
      message += "Please enter Phone Ext.<br/>";
      isValid = false;
    } else {
      const phoneformat = /^[1-9]\d*$/;
      formData.PHONE_EXT = formData.PHONE_EXT + "";
      if (formData.PHONE_EXT.match(phoneformat)) {
        $("#PHONE_EXT").addClass("ng-untouched ng-valid");
        $("#PHONE_EXT").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#PHONE_EXT").addClass("ng-touched ng-invalid validate-error");
        $("#PHONE_EXT").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Other Phone Ext.<br/>";
        isValid = false;
      }
    }


    if (formData.FAX === null || formData.FAX === "") {
      $("#FAX").addClass("ng-touched ng-invalid validate-error");
      $("#FAX").removeClass("ng-untouched ng-valid");
      message += "Please enter Fax.<br/>";
      isValid = false;
    } else {
      $("#FAX").addClass("ng-untouched ng-valid");
      $("#FAX").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.FAX_EXT === null || formData.FAX_EXT === "") {
      $("#FAX_EXT").addClass("ng-touched ng-invalid validate-error");
      $("#FAX_EXT").removeClass("ng-untouched ng-valid");
      message += "Please enter Fax Ext.<br/>";
      isValid = false;
    } else {
      $("#FAX_EXT").addClass("ng-untouched ng-valid");
      $("#FAX_EXT").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
    this.commonService.ValidationBanner(message)
    //  this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
    return isValid;
  }

}
